import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import NotFound from '../../pages/NotFound';
import ImageGallery from '../ImageGallery';
import LotDescription from './components/LotDescription';
import LotDetails from './components/LotDetails';
import { useStores } from 'stores';
import styles from './Lot.module.scss';

const Lot = () => {
  const {
    singleLotStore: { singleLotNotFound, singleLot, isLoading },
  } = useStores();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return;
  }

  return singleLotNotFound !== null ? (
    <div className={styles.bns3_mainContainer}>
      <div className={styles.bns3_lot_container}>
        <div className={styles.bns3_flex_wrapper}>
          <div className={styles.bns3_lot_gallery_container}>
            <ImageGallery images={singleLot.images} />
          </div>
          <div className={styles.bns3_lot_details_container}>
            <LotDetails />
          </div>
        </div>
        <div className={styles.bns3_lot_description_container}>
          <LotDescription />
        </div>
      </div>
    </div>
  ) : (
    <NotFound />
  );
};

export default observer(Lot);
